
import PropTypes from 'prop-types'
import React from 'react'
import './FormFooter.css'

const FormFooter = ({ children }) => (
  <div className='FormFooter'>{children}</div>
)

FormFooter.propTypes = {
  children: PropTypes.oneOfType([ PropTypes.object, PropTypes.array ]).isRequired
}

FormFooter.displayName = 'FormFooter'

export default FormFooter



// WEBPACK FOOTER //
// ./ui/FormFooter.js